import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SkillService {


  //CHECK SKILLS UND KUNDENTEAM
  checkSkillsAndKundenteam(event: any){
    const resources = event.resource;
    const customers = event['customer'];
    const isTempEvent = event.isTempEvent;
    const isNotKundenteam = this.checkIsNotInKundenteam(resources, customers, isTempEvent);
    //const missingSkill = this.checkResourceSkillsForEvent();

    return (isNotKundenteam); //TRUE FÜR WARNUNG ANZEIGEN
  }


  //SCHAUEN OB DIE AKTUELLE RESOURCE IM KUNDENTEAM DER ZUGEWIESENEN KUNDEN IST - TRUE/FALSE
  checkIsNotInKundenteam(resources: any, customers: any, isTempEvent: boolean) {

    if(isTempEvent){
      const resourcesToArray = [resources];
      resources = resourcesToArray;
    }

    if ((!Array.isArray(resources) && !isTempEvent) || !Array.isArray(customers)) {
      return false;
    }

    const hasAnyKundenteam = customers.some(
      (customer: any) =>
        Array.isArray(customer.stammkundenDolmetscher) &&
        customer.stammkundenDolmetscher.length > 0
    );
  

    if (!hasAnyKundenteam) {
      return false;
    }

    const isNotInKundenteam =
      resources.some((resourceId: any) =>
        customers.some(
          (customer: any) =>
            Array.isArray(customer.stammkundenDolmetscher) &&
            customer.stammkundenDolmetscher.includes(resourceId)
        )
      );

    return !isNotInKundenteam;
  }


  //DIE DOLMETSCHER IDs FINDEN DIE NICHT ZUM KUNDEN GEHÖREN
  getNonKundenteamIds(allIds: any, allKundenteamIds: any){
    const nonKundenteamIds = allIds.filter(
      (id: any) => !allKundenteamIds.includes(id)
    );

    return nonKundenteamIds;
  }


  //DOLMETSCHER IDs AUS DEN KUNDEN HOLEN
  getAllKundenteamIds(customers: any){
    const kundenteamIds = customers
    .flatMap((customer: any) => customer.stammkundenDolmetscher ?? []);
  
    return kundenteamIds;
  }
}
